import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Mission } from '../interfaces/candidate.interface';

@Component({
  selector: 'app-mission-info',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
    <div class="mission-info-card">
      <h2 class="mission-title">Offre de mission</h2>
      
      <div class="mission-details">
        <div class="info-row">
          <div class="info-group">
            <label>Référence :</label>
            <span class="info-text">{{ mission.reference }}</span>
          </div>
          <div class="info-group">
            <label>Poste :</label>
            <span class="info-text">{{ mission.post }}</span>
          </div>
        </div>
        
        <div class="info-row">
          <div class="info-group">
            <label>Date de début :</label>
            <span class="info-text">{{ mission.startDate | date:'dd/MM/yyyy' }}</span>
          </div>
          <div class="info-group">
            <label>Date de fin :</label>
            <span class="info-text">{{ mission.endDate | date:'dd/MM/yyyy' }}</span>
          </div>
        </div>
        
        <div class="info-row">
          <div class="info-group">
            <label>Établissement :</label>
            <span class="info-text">{{ mission.establishment }}</span>
          </div>
          <div class="info-group">
            <label>Site :</label>
            <span class="info-text">{{ mission.site }}</span>
          </div>
          <div class="info-group">
            <label>Service d'affectation :</label>
            <span class="info-text">{{ mission.assignmentService }}</span>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .mission-info-card {
      background: white;
      border-radius: 8px;
      padding: 24px;
      margin-bottom: 24px;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    }

    .mission-title {
      margin: 0 0 20px 0;
      color: #333;
      font-size: 20px;
      font-weight: 600;
    }

    .mission-details {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }

    .info-row {
      display: flex;
      gap: 20px;
      flex-wrap: wrap;
    }

    .info-group {
      display: flex;
      flex-direction: column;
      flex: 1;
      min-width: 200px;
    }

    .info-group label {
      font-weight: 500;
      color: #555;
      margin-bottom: 6px;
      font-size: 14px;
    }

    .info-text {
      padding: 8px 12px;
      background-color: #f8f9fa;
      border-radius: 4px;
      font-size: 14px;
      color: #333;
      min-height: 36px;
      display: flex;
      align-items: center;
    }

    @media (max-width: 768px) {
      .info-row {
        flex-direction: column;
      }
      
      .info-group {
        min-width: unset;
      }
    }
  `]
})
export class MissionInfoComponent {
  @Input() mission!: Mission;
  @Output() missionChange = new EventEmitter<Mission>();

  onMissionChange(): void {
    this.missionChange.emit(this.mission);
  }
}